module.exports = __webpack_public_path__ + "static/media/martin_bernstein_2.95232947.png";